import { VueModule } from '@Foundation/utilities';
import PharmacyCtaButton from './code/Scripts/components/pharmacy-cta-button.vue';

export default VueModule({
    components: {
        PharmacyCtaButton
    }
});